export const DATE_FORMAT = ['MMDDYYYY', 'MMDDYY'];
